import './home.scss'
import React, { useState, useEffect } from 'react'
import Navbar from '../../components/navbar/navbar'
import BreadcrumbSample from '../../components/breadcrumb/breadcrumb'
import api_host from '../../env'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import MailFilter from './mailFilter'

const MessageHistory = ({ setDetailViewType, setView, searchedAccountID, history }) => {
  const [emailsError, setEmailsError] = useState(null)
  const [paginationError, setPaginationError] = useState(null)
  const [emails, setEmails] = useState([])
  const [spinner, setSpinner] = useState(false)
  const [currentPage, setCurrentPage] = useState('1')
  const [pageNumInput, setPageNumInput] = useState('1')
  const [totalMails, setTotalMails] = useState(0)
  const [maxPages, setMaxPages] = useState(1)
  const [filter, setFilter] = useState(null)
  const handlePageNumUpdate = ({ currentTarget }) => {
    setPageNumInput(currentTarget.value)
  }

  const handleKeyDown = ({ key, keyCode, currentTarget }) => {
    if (key === 'Enter' || keyCode === 13) {
      if (currentTarget.value >= 1 && currentTarget.value <= maxPages) {
        setPaginationError(null)
        setCurrentPage(currentTarget.value.trim())
      } else {
        setPaginationError(`Page number should be between 1 and ${maxPages}`)
      }
    }
  }

  const getMails = () => {
    if (!sessionStorage.getItem('token')) {
      setEmailsError('User not logged in')
      return
    }
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      },
      body: (filter && filter.filters) ? JSON.stringify(filter) : null
    }
    setEmailsError(null)
    setPageNumInput(currentPage)
    setPaginationError(null)
    setSpinner(true)
    fetch(
      `${api_host}/accounts/${searchedAccountID}/mailboxes/inbox/history?pageSize=20&pageNumber=${currentPage || 1
      }`,
      config
    )
      .then(res => res.json())
      .then(data => {
        setSpinner(false)
        if (data && ((data.message && data.message.indexOf('Failed - Invalid Token') > -1) || (data.error && data.error.indexOf('Failed - Invalid SessionGUID') > -1))) {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else if (data && data.error && Array.isArray(data.error)) {
          setEmailsError(data.error.join('\n'))
        } else if (data && data.error && !Array.isArray(data.error)) {
          setEmailsError(data.error)
        } else if (data && data.messages) {
          if (data.messages.length == 0) {
            setEmailsError('No messages in the history mailbox')
            setTotalMails(0)
            setMaxPages(0)
          } else {
            setEmails(data.messages)
            setMaxPages(data.totalPages)
            setTotalMails(data.totalMessageCount)
          }
        } else {
          setEmailsError('Something went wrong')
        }
      })
      .catch(() => setEmailsError('Something went wrong'))
  }
  useEffect(() => {
    if (filter == null) {
      return
    }
    if (currentPage == 1) {
      getMails()
    } else {
      setCurrentPage(1)
    }
  }, [filter])

  useEffect(() => {
    getMails()
  }, [currentPage])

  return (
    <>
      <Navbar />
      <BreadcrumbSample
        goToHome={() => setView('home')}
        goToAccDetail={() => setDetailViewType('account')}
        activePage="Message History"
      />
      <MailFilter setFilter={setFilter} filter={filter} />
      <div className="table-wrapper">
        {emailsError && <p className="error">{emailsError}</p>}
        {maxPages > 0 && <Table
          striped
          bordered
          responsive="true"
        >
          <thead>
            <tr>
              <th>Received On</th>
              <th>From</th>
              <th>Message Subject</th>
              <th>Deleted On</th>
              <th>Message Type</th>
            </tr>
          </thead>
          <tbody>
            {emails.map(
              ({
                receivedOn,
                mailFrom,
                mailSubject,
                messageType,
                deletedOn,
                messageGUID
              }) => (
                <tr key={messageGUID}>
                  <td>{receivedOn}</td>
                  <td>{mailFrom}</td>
                  <td>{mailSubject}</td>
                  <td>{deletedOn}</td>
                  <td>{messageType}</td>
                </tr>
              )
            )}
          </tbody>
        </Table>}
      </div>
      {maxPages != 0 && maxPages > 1 ? (
        <div>
          <p className="total-mails">Total Messages in Inbox: {totalMails}</p>
          <div className="pagination">
            <button
              className={currentPage > 1 ? 'pagination-btn' : 'disabled-pg-btn'}
              disabled={!(currentPage > 1)}
              onClick={() => setCurrentPage(pg => Number(pg) - 1)}
            >
              {' '}
              &lt; &nbsp; Previous
            </button>
            <input
              onChange={handlePageNumUpdate}
              onKeyDown={handleKeyDown}
              type="text"
              data-testid="pagination-input"
              value={pageNumInput}
              className='pagination-input'
            />{' '}
            <span className="space-right">&nbsp; / {maxPages}</span>
            <button
              className={
                currentPage >= maxPages ? 'disabled-pg-btn' : 'pagination-btn'
              }
              disabled={currentPage >= maxPages}
              onClick={() => {
                setCurrentPage(pg => Number(pg) + 1)
              }}
            >
              Next &nbsp; &gt;
            </button>
          </div>
        </div>
      ) : (
        <p className="total-mails">Total Messages in Inbox: {totalMails}</p>
      )}
      {paginationError && (
        <p className="error pagination-error">{paginationError}</p>
      )}
      {spinner && (
        <Spinner
          animation="border"
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      )}
    </>
  )
}

export default MessageHistory
